import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import { OnboardingStep } from "../../../Onboarding/types";

export const StepSuccess: React.FC<OnboardingStep> = props => {
  return (
    <WSList gap="2XL">
      <WSCard>
        <WSEmptyState
          type="done"
          title="Your enrollment was submitted!"
          description="Your enrollment was submitted and is currently being processed which could take 1-2 days."
        />
      </WSCard>
      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Back to benefits",
            onClick: props.onNext
          }
        ]}
      />
    </WSList>
  );
};
